import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import type React from 'react';

import { useConfig } from 'src/hooks/useConfig';
import type { Job } from 'src/types';
import { buildTalentSearchJobUrl } from 'src/utils/talentsearch';

import { EmptyTableCell } from '../EmptyTableCell';
import { Skeleton } from '../Skeleton/Skeleton';
import { TrackingLink } from '../TrackingLink/TrackingLink';

import translations from './.vocab';

interface JobProps {
  job: Job;
  loading?: boolean;
}

export const JobTalentSearch: React.FC<React.PropsWithChildren<JobProps>> = ({
  job,
  loading = false,
}) => {
  const { t } = useTranslations(translations);
  const { urlResolver } = useConfig();

  if (loading) {
    return (
      <Text>
        <Skeleton loading={loading} numberOfCharacters={13} />
      </Text>
    );
  }

  if (job.status !== 'ACTIVE') {
    return <EmptyTableCell />;
  }

  return (
    <Text size="small">
      <TrackingLink
        intercomid="talentSearchLink"
        href={buildTalentSearchJobUrl(job.jobId, urlResolver)}
        weight="weak"
        eventName="job_talent_search_pressed"
        eventAttributes={{ jobId: job.jobId }}
        target="_blank"
      >
        {t('Find candidates')}
      </TrackingLink>
    </Text>
  );
};
